/**
 * Returns the best available profile picture URL for a supporter.
 * Priority: supporterProfilePictureURL > chosenProfilePicImageURL > null.
 *
 * @param {string} supporterProfilePictureURL - The main supporter profile picture URL.
 * @param {string} chosenProfilePicImageURL - The chosen profile picture URL (optional/secondary).
 * @returns {string|null} - The resolved profile picture URL or null if none.
 */
export const getProfilePictureURL = (
  supporterProfilePictureURL,
  chosenProfilePicImageURL
) => {
 // Return the first non-empty, non-whitespace value, or null
  if (
    typeof supporterProfilePictureURL === "string" &&
    supporterProfilePictureURL.trim()
  ) {
    return supporterProfilePictureURL;
  }
  if (
    typeof chosenProfilePicImageURL === "string" &&
    chosenProfilePicImageURL.trim()
  ) {
    return chosenProfilePicImageURL;
  }
  return null;
};

/**
 * Returns the best available full-size profile picture URL for a supporter.
 * Priority: supporterProfilePictureFullURL > chosenProfilePicImageURL > null.
 *
 * @param {string} supporterProfilePictureFullURL - The main full-size supporter profile picture URL.
 * @param {string} chosenProfilePicImageURL - The chosen full-size profile picture URL (optional/secondary).
 * @returns {string|null} - The resolved full-size profile picture URL or null if none.
 */
export const getProfilePictureFullURL = (
  supporterProfilePictureFullURL,
  chosenProfilePicImageURL,
) => {
  // Return the first non-empty, non-whitespace value, or null
  if (
    typeof supporterProfilePictureFullURL === "string" &&
    supporterProfilePictureFullURL.trim()
  ) {
    return supporterProfilePictureFullURL;
  }
  if (
    typeof chosenProfilePicImageURL === "string" &&
    chosenProfilePicImageURL.trim()
  ) {
    return chosenProfilePicImageURL;
  }
  return null;
};
